<template>
  <div class="invoices-filters">
    <form-group
      class="mt-3"
      id="product-select"
      select
      label="Produto"
      v-model="form.product_id"
      :options="productOptions"
    />
    <form-group
      class="mb-3"
      id="status-select"
      label="Status"
      placeholder="Todos os status"
      select
      v-model="form.status"
      :options="statusOptions"
      multiple
    />
    <label for="send-dates">Data de emissão</label>
    <input
      readonly
      class="form-control bg-white mb-5"
      id="send-dates"
      placeholder="Selecione o período de emissão"
      @click="sendPicker = true"
      :value="datesString(sendDates)"
    />
    <label for="payment-dates">Data de pagamento</label>
    <input
      readonly
      class="form-control bg-white mb-5"
      id="payment-dates"
      placeholder="Selecione o período de pagamento"
      @click="paymentPicker = true"
      :value="datesString(paymentDates)"
    />
    <responsive-modal v-model="sendPicker">
      <date-picker
        v-model="sendDates"
        :visible="true"
        @hide="sendPicker = false"
        positionRelative
        showCancelBtn
      />
    </responsive-modal>
    <responsive-modal v-model="paymentPicker">
      <date-picker
        v-model="paymentDates"
        :visible="true"
        @hide="paymentPicker = false"
        positionRelative
        showCancelBtn
      />
    </responsive-modal>

    <div class="row pt-5">
      <div class="col-lg-6 d-none d-lg-block">
        <button class="btn btn-block btn-new-secondary" @click="$emit('close')">
          Cancelar
        </button>
      </div>
      <div class="col-lg-6">
        <button class="btn btn-block btn-new-primary" @click="apply">
          Aplicar
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { clearObject, formFields } from "@/functions/helpers";
import { mapState } from "vuex";
export default {
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      sendPicker: false,
      paymentPicker: false,
      sendDates:
        this.value && this.value.send_at_after && this.value.send_at_before
          ? [this.value.send_at_after, this.value.send_at_before]
          : null,
      paymentDates:
        this.value && this.value.paid_at_after && this.value.paid_at_before
          ? [this.value.paid_at_after, this.value.paid_at_before]
          : null,
      ...formFields(
        [
          "product_id",
          "status",
          "send_at_after",
          "send_at_before",
          "paid_at_after",
          "paid_at_before"
        ],
        { ...this.value }
      )
    };
  },
  watch: {
    sendDates(dates) {
      if (dates && dates.length === 2) {
        this.form.send_at_after = dates[0];
        this.form.send_at_before = dates[1];
      } else {
        this.form.send_at_after = null;
        this.form.send_at_before = null;
      }
    },
    paymentDates(dates) {
      if (dates && dates.length === 2) {
        this.form.paid_at_after = dates[0];
        this.form.paid_at_before = dates[1];
      } else {
        this.form.paid_at_after = null;
        this.form.paid_at_before = null;
      }
    }
  },
  computed: {
    ...mapState("product", ["products"]),
    productOptions() {
      return [{ id: "", name: "Todos os produtos" }, ...this.products];
    },
    statusOptions() {
      return [
        { id: "sent", name: "Enviado" },
        { id: "pending", name: "Pendente" },
        { id: "failed", name: "Falha" },
        { id: "canceled", name: "Cancelado" }
      ];
    }
  },
  methods: {
    apply() {
      this.$emit("input", clearObject(this.form));
      this.$emit("onFiltersApply");
    },
    datesString(dates) {
      const format = date =>
        date
          .split("-")
          .reverse()
          .join("/");
      return dates && dates.length === 2
        ? `${format(dates[0])} - ${format(dates[1])}`
        : "";
    }
  },
  mounted() {
    this.$store.dispatch("product/get");
  }
};
</script>
<style lang="scss" scoped>
.invoices-filters {
  label {
    font-weight: 400;
    color: #595463;
    font-size: 14px;
  }
}
</style>
